<template>
  <div>
    <b-modal id="modal-global" :title="this.modalTitle" cancel-title="true" :no-close-on-backdrop="modal.closeBackdrop" :no-close-on-esc="modal.closeBackdrop">
      <div class="modal-logo" v-if="!modal.hideLogo"><img src="../assets/logo.png" height="130"></div>
        <component :is="loadComponent"></component> 
      <div slot="modal-footer" :v-if="!modal.footer">&nbsp;</div>
    </b-modal>
  </div>
</template>
<script>
  import { mapState, mapActions } from "vuex"; 
  
  export default {
    name: "modal",
    data: function (){
      return {
        loadComponent: null,
        closeBackdrop: true
      }
    },
    methods: {
      pushModal() {
        this.$bvModal.show('modal-global')
      },
      popModal() {
        this.$bvModal.hide('modal-global')
      },
      ...mapActions(['hideModal'])
    },
    computed: {
      ...mapState(['modal']),
      modalTitle(){
        return this.modal.title
      },
      modalState (){
        return this.modal.show
      },
      modalComponent (){
        return this.modal.component
      }
    },
    watch: {
      modalComponent: function (){
        if (this.modal.show){
          this.pushModal()           
          this.loadComponent = this.modal.component
        } else {
          this.popModal()
        }
      }
    },
    mounted() {
      this.$root.$on('bv::modal::hide', () => {
        this.hideModal()
      })
    }
  }

</script>
